import "./App.css"
import UsersList from "./components/UsersList"

function App() {
  return (
    <div>
      <header className="header px-10 py-6">
        <h1 className="text-lg tracking-wider">
          Stores-Products App with Redux Toolkit
        </h1>
      </header>
      <main className="container m-auto">
        <div className="mt-10 p-3">
          <UsersList />
        </div>
      </main>
    </div>
  )
}

export default App
